import { routes } from '@data/routes';
import useApi from '@hooks/useApi';
import { CorporateFareRounded } from '@mui/icons-material';
import {
    Avatar,
    Box,
    InputBase,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
} from '@mui/material';
import { useAuthInfo } from '@propelauth/react';
import { Link, useLocation } from '@tanstack/react-router';
import SettingsNavigation from '@Views/Settings/navigation';
import { useTranslation } from 'react-i18next';

const SecondaryNavigation = () => {
    const { t } = useTranslation('controls');
    const { orgHelper, user } = useAuthInfo();
    const orgs = orgHelper?.getOrgs();
    const { activeOrg, setActiveOrg } = useApi();
    const [mainRoute, secondaryRoute] = useLocation()
        .pathname.split('/')
        .filter(Boolean)
        .slice(0, 2);

    const linkRoutes =
        routes.find(route => route.path === '/' + mainRoute)?.routes || [];
    const selectedRoute =
        linkRoutes.find(route => route.path === '/' + secondaryRoute)?.path ||
        '/';
    const isSettings = mainRoute === 'settings';

    return (
        <Box width={isSettings ? 264 : 234} sx={{ px: 1.5 }}>
            <Box sx={{ my: 1.5 }}>
                <Select
                    input={<InputBase />}
                    value={activeOrg.orgId}
                    onChange={e => setActiveOrg(e.target.value)}
                    fullWidth
                    sx={{
                        backgroundColor: 'surfaceVariant.main',
                        borderRadius: theme => theme.shape.lg,
                    }}
                    renderValue={value => (
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar>
                                    <CorporateFareRounded />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={activeOrg.orgName}
                                secondary={
                                    [user?.firstName, user?.lastName]
                                        .filter(Boolean)
                                        .join(' ') || user?.email
                                }
                                primaryTypographyProps={{ noWrap: true }}
                                secondaryTypographyProps={{ noWrap: true }}
                            />
                        </ListItem>
                    )}
                >
                    {orgs.map(org => (
                        <MenuItem key={org.orgId} value={org.orgId}>
                            {org.orgName}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            {isSettings && <SettingsNavigation />}
            <List>
                <Box>
                    {linkRoutes.map(({ name, path, Icon, SelectedIcon }) => {
                        const selected = path === selectedRoute;
                        return (
                            <ListItem key={path} sx={{ px: 0 }}>
                                <ListItemButton
                                    component={Link}
                                    to={'/' + mainRoute + path}
                                    // from={mainRoute}
                                    selected={selected}
                                >
                                    <ListItemIcon>
                                        {selected ? (
                                            <SelectedIcon fontSize="small" />
                                        ) : (
                                            <Icon fontSize="small" />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText>{t(name)}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </Box>
            </List>
        </Box>
    );
};

export default SecondaryNavigation;
